import { trpc as IssueStatistics } from '@tencent/tpro_rmonitor_web_server_issue_statistics';
import { WithTypeCast } from '@raft/utils';

// 获取问题版本信息数据
export type IGetVersionReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetVersionReq>;
export type IGetVersionRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetVersionRsp>;
export type IVersion = WithTypeCast<IssueStatistics.rmonitor.web_server.IVersion>;
// 获取问题趋势数据
export type IGetTrendReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetTrendReq>;
export type IGetTrendRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetTrendRsp>;
export type ITrend = WithTypeCast<IssueStatistics.rmonitor.web_server.ITrend>;
export type StatData = WithTypeCast<IssueStatistics.rmonitor.web_server.StatData>;

export const { StatData } = IssueStatistics.rmonitor.web_server;

export type TimeType = IssueStatistics.rmonitor.web_server.TimeType;

export const { TimeType } = IssueStatistics.rmonitor.web_server;

// 获取支持问题分布统计的维度
export type IGetDistributionKeysReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetDistributionKeysReq>;
export type IGetDistributionKeysRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetDistributionKeysRsp>;
export type IKey = WithTypeCast<IssueStatistics.rmonitor.web_server.IKey>;
// 获取问题分布数据
export type IGetDistributionReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetDistributionReq>;
export type IGetDistributionRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetDistributionRsp>;
export type IDistribution = WithTypeCast<IssueStatistics.rmonitor.web_server.IDistribution>;
export const { IssueMetricType } = IssueStatistics.rmonitor.web_server;
export type IssueMetricType =WithTypeCast<IssueStatistics.rmonitor.web_server.IssueMetricType>;
// 获取问题概览数据 不受筛选条件影响
export type IGetSummaryReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetSummaryReq>;
export type IGetSummaryRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetSummaryRsp>;
// 获取问题概览数据 -- 下钻分析页面
export type IGetSummaryDrillDownReq = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetSummaryDrillDownReq>;
export type IGetSummaryDrillDownRsp = WithTypeCast<IssueStatistics.rmonitor.web_server.IGetSummaryDrillDownRsp>;
